var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpottLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)",
    fill: "none",
    stroke: "#2E3F8B",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6L53.65 18.5V43.5L32 56L10.35 43.5V18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 31L10.35 18.5M32 31L53.65 18.5M32 31V56"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 43,
    r: 4.6,
    fill: "#EF9F27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpottLogo);
export default __webpack_public_path__ + "static/media/spott-logo.3c6aac3fd51dbb0a270970390c2e4b57.svg";
export { ForwardRef as ReactComponent };